/* eslint-disable no-underscore-dangle */
/* eslint-disable lines-between-class-members */
/* eslint-disable max-classes-per-file */
/* eslint-disable class-methods-use-this */

import { getAppType } from 'app/utils/browser';
import Raven from 'raven-js';

const firebaseConfig = {
    apiKey: 'AIzaSyADSZddXI8uIP4ypvUEJCqE7wU-_LcIom0',
    authDomain: 'elementaree-prod.firebaseapp.com',
    projectId: 'elementaree-prod',
    storageBucket: 'elementaree-prod.firebasestorage.app',
    messagingSenderId: '114588927176',
    appId: '1:114588927176:web:813b052997960e994111fd',
    measurementId: 'G-M0CEESBE8F',
};

class FirebaseAppClient {
    constructor() {
        this.firebaseApp = null;
    }
    init() {
        try {
            if (window.firebase.apps.length) {
                this.firebaseApp = window.firebase.app();
            } else {
                this.firebaseApp = window.firebase.initializeApp(firebaseConfig);
            }
        } catch (error) {
            console.log(error);
            Raven.captureMessage(
                '[Anlalytics error]: Firebase init error',
                {
                    tags: { type: 'Auth error' },
                    extra: { error },
                },
            );
        }
    }
    getApp() {
        return this.firebaseApp;
    }
}

class FirebaseAnalyticsAndroidClient {
    constructor() {
        this.service = {
            logEvent: () => { },
        };
        this.clientName = 'FirebaseAnalyticsAndroid';
        this._init();
    }

    _init() {
        try {
            const firebaseApp = new FirebaseAppClient();
            firebaseApp.init();

            // TODO: Пример
            // const anotherFirebaseApp = new FirebaseAppClient();
            // anotherFirebaseApp.init();
            // console.log(firebaseApp.getApp() === anotherFirebaseApp.getApp());

            this.service = window.firebase.analytics();
        } catch (e) {
            console.error(e);
        }
    }

    emit(data) {
        const { event, ...otherParams } = data;

        const screenName = window.location.pathname;

        const eventParams = {
            platform: getAppType(),
            firebase_screen: screenName,
            ...otherParams,
        };

        // console.log(`emit ${this.clientName} event:`, data);
        console.warn(event, { ...eventParams });
        this.service.logEvent(event, { ...eventParams });
    }
}

class FirebaseAnalyticsIOSClient {
    constructor() {
        this.service = {
            logEvent: () => { },
        };
        this.clientName = 'FirebaseAnalyticsIOS';
        this._init();
    }
    _init() {
        /**
        * Инициализция происходит в нативной части приложения,
        * взаимодйествие с которой происходит через
        * window.webkit.messageHandlers.analyticsMessageHandler
        */
    }

    emit(data) {
        const { event, ...otherParams } = data;

        const screenName = window.location.pathname;

        const eventParams = {
            platform: getAppType(),
            screenName,
            ...otherParams,
        };

        window.webkit.messageHandlers.analyticsMessageHandler.postMessage({
            eventName: event,
            eventParams,
        });
        // console.log('emit FirebaseAnalyticsClient IOS event:', data, eventParams);
    }
}

/**
 * @implements factry method
 */
export class FirebaseAnalyticsClientFactory {
    constructor() {
        this.mobileAnalytucsClient = null;
        this.isNativeAppAnalytics = this._getIsNativeAppAnalytics();
    }
    _getIsNativeAppAnalytics() {
        return window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.analyticsMessageHandler;
    }


    create() {
        this.mobileAnalytucsClient = this.isNativeAppAnalytics
            ? new FirebaseAnalyticsIOSClient()
            : new FirebaseAnalyticsAndroidClient();
        return this;
    }

    getClient() {
        return this.mobileAnalytucsClient;
    }
}

